<script>
  import Icon from "@iconify/svelte";
  import { locale, setLocale, SUPPORTED } from "../lib/i18n";

  const FLAGS = {
    en: "circle-flags:us",
    fr: "circle-flags:fr",
    es: "circle-flags:es",
    pt: "circle-flags:pt",
  };

  const LABELS = { en: "English", fr: "Français", es: "Español", pt: "Português" };

  let open = false;

  function select(code) {
    setLocale(code);
    open = false;
  }
</script>

<div class="relative" role="group">
  <button
    type="button"
    class="inline-flex items-center justify-center gap-1.5 rounded-lg border border-neutral-600/50 bg-neutral-800/40 px-2.5 py-2 text-sm text-neutral-200 hover:bg-neutral-700/50 transition-colors"
    on:click={() => (open = !open)}
    on:blur={() => setTimeout(() => (open = false), 150)}
    aria-haspopup="listbox"
    aria-expanded={open}
    aria-label="Language"
    title="Language"
  >
    <Icon icon={FLAGS[$locale] || FLAGS.en} class="h-5 w-5 rounded-full" />
    <span class="hidden sm:inline text-xs uppercase text-neutral-400">{$locale}</span>
    <Icon icon="mdi:chevron-down" class="h-4 w-4 text-neutral-500 transition-transform {open ? 'rotate-180' : ''}" />
  </button>

  {#if open}
    <ul
      class="absolute right-0 top-full mt-1.5 min-w-[140px] rounded-lg border border-neutral-700 bg-neutral-900 py-1 shadow-xl z-[60]"
      role="listbox"
    >
      {#each SUPPORTED as code}
        <li role="option" aria-selected={$locale === code}>
          <button
            type="button"
            class="flex items-center gap-2 w-full px-3 py-2 text-left text-sm {$locale === code ? 'bg-neutral-700/60 text-white' : 'text-neutral-300 hover:bg-neutral-800 hover:text-white'}"
            on:click={() => select(code)}
          >
            <Icon icon={FLAGS[code]} class="h-5 w-5 rounded-full shrink-0" />
            <span>{LABELS[code]}</span>
          </button>
        </li>
      {/each}
    </ul>
  {/if}
</div>
